// extracted by mini-css-extract-plugin
module.exports = {"modalTitle":"style__modalTitle___C_B2_","modalContents":"style__modalContents___39SEC","discardButton":"style__discardButton___iqH-t","buttonIcon":"style__buttonIcon___3Gp7q"};